import styled from 'styled-components';

export const Container = styled.div`
  padding: ${props => props.padding || '25px'};
  margin-top: ${props => props.top || '0px'};
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  ${props => {
    if (props.maxHeight) {
      return 'height: 95%;';
    }
    return '';
  }};
`;
